// ELV3DataConfig.js

// Device Part choices, matching your screenshots.
// Each item has a `label` plus an array of `categories` that includes both
// its specific location (e.g. "Inside Car") AND "All Types" so you can still
// filter by "All Types" if desired.
export const devicePartOptions = [
  // Inside Car (#1–15)
  { label: '01. Emergency stop switch', categories: ['Inside Car', 'All Types'] },
  { label: '02. Alarm system', categories: ['Inside Car', 'All Types'] },
  { label: '03. Car enclosure', categories: ['Inside Car', 'All Types'] },
  { label: '04. Side emergency exit', categories: ['Inside Car', 'All Types'] },
  { label: '05. Car door/gate', categories: ['Inside Car', 'All Types'] },
  { label: '06. Car door/gate Contact', categories: ['Inside Car', 'All Types'] },
  { label: '07. Door reopening device', categories: ['Inside Car', 'All Types'] },
  { label: '08. Car floor to landing sill', categories: ['Inside Car', 'All Types'] },
  { label: '09. Car floor', categories: ['Inside Car', 'All Types'] },
  { label: '10. Car door gibs', categories: ['Inside Car', 'All Types'] },
  { label: '11. Car button station', categories: ['Inside Car', 'All Types'] },
  { label: '12. Car lighting', categories: ['Inside Car', 'All Types'] },
  { label: '13. Emergency lighting', categories: ['Inside Car', 'All Types'] },
  { label: '14. Car mirror', categories: ['Inside Car', 'All Types'] },
  { label: '15. Certificate frame', categories: ['Inside Car', 'All Types'] },

  // Outside Hoistway (#16–25)
  { label: '16. Hoistway doors', categories: ['Outside Hoistway', 'All Types'] },
  { label: '17. Hoistway door gibs', categories: ['Outside Hoistway', 'All Types'] },
  { label: '18. Hoistway Door Reinforcements', categories: ['Outside Hoistway', 'All Types'] },
  { label: '19. Hoistway Door Safety Retainer', categories: ['Outside Hoistway', 'All Types'] },
  { label: '20. Vision Panel', categories: ['Outside Hoistway', 'All Types'] },
  { label: '21. Interlocks', categories: ['Outside Hoistway', 'All Types'] },
  { label: '22. Parking device', categories: ['Outside Hoistway', 'All Types'] },
  { label: '23. Hall button station', categories: ['Outside Hoistway', 'All Types'] },
  { label: '24. Indicators', categories: ['Outside Hoistway', 'All Types'] },
  { label: '25. Door safety retainer', categories: ['Outside Hoistway', 'All Types'] },

  // Top of Car (#26–39)
  { label: '26. Top emergency exit cover', categories: ['Top of Car', 'All Types'] },
  { label: '27. Governor release carrier', categories: ['Top of Car', 'All Types'] },
  { label: '28. Door hangers & connectors', categories: ['Top of Car', 'All Types'] },
  { label: '29. Door operator', categories: ['Top of Car', 'All Types'] },
  { label: '30. Normal limits', categories: ['Top of Car', 'All Types'] },
  { label: '31. Final limits', categories: ['Top of Car', 'All Types'] },
  { label: '32. Guide Shoes/Roller Guides', categories: ['Top of Car', 'All Types'] },
  { label: '33. Counterweight', categories: ['Top of Car', 'All Types'] },
  { label: '34. Hoistway', categories: ['Top of Car', 'All Types'] },
  { label: '35. Electric wiring', categories: ['Top of Car', 'All Types'] },
  { label: '36. Pipes and ducts', categories: ['Top of Car', 'All Types'] },
  { label: '37. Overhead and deflector sheave', categories: ['Top of Car', 'All Types'] },
  { label: '38. Traveling cable & junction', categories: ['Top of Car', 'All Types'] },
  { label: '39. Car top', categories: ['Top of Car', 'All Types'] },

  // Machine Room (#40–63)
  { label: '40. Machine room', categories: ['Machine Room', 'All Types'] },
  { label: '41. Machine room door', categories: ['Machine Room', 'All Types'] },
  { label: '42. Controller - selector', categories: ['Machine Room', 'All Types'] },
  { label: '43. Reverse phase relay', categories: ['Machine Room', 'All Types'] },
  { label: '44. Traction sheave', categories: ['Machine Room', 'All Types'] },
  { label: '45. Governor', categories: ['Machine Room', 'All Types'] },
  { label: '46. Governor Switch', categories: ['Machine Room', 'All Types'] },
  { label: '47. Drum', categories: ['Machine Room', 'All Types'] },
  { label: '48. Pump unit', categories: ['Machine Room', 'All Types'] },
  { label: '49. Drum Machine Limit S/W', categories: ['Machine Room', 'All Types'] },
  { label: '50. Generator', categories: ['Machine Room', 'All Types'] },
  { label: '51. Slack Rope Switch', categories: ['Machine Room', 'All Types'] },
  { label: '52. Hoist Ropes', categories: ['Machine Room', 'All Types'] },
  { label: '53. Governor Ropes', categories: ['Machine Room', 'All Types'] },
  { label: '54. Car Counterweight Rope', categories: ['Machine Room', 'All Types'] },
  { label: '55. Drum Counterweight Rope', categories: ['Machine Room', 'All Types'] },
  { label: '56. Hoist Machine', categories: ['Machine Room', 'All Types'] },
  { label: '57. Hoist Motor', categories: ['Machine Room', 'All Types'] },
  { label: '58. Worm/Gear/Bearings', categories: ['Machine Room', 'All Types'] },
  { label: '59. Machine brake', categories: ['Machine Room', 'All Types'] },
  { label: '60. Lighting machine space', categories: ['Machine Room', 'All Types'] },
  { label: '61. Machine Disconnect S/W', categories: ['Machine Room', 'All Types'] },
  { label: '62. Commutator', categories: ['Machine Room', 'All Types'] },
  { label: '63. Motor Brushes', categories: ['Machine Room', 'All Types'] },

  // Pit (#70–82)
  { label: '70. Pit', categories: ['Pit', 'All Types'] },
  { label: '71. Pit light', categories: ['Pit', 'All Types'] },
  { label: '72. Pit stop switch', categories: ['Pit', 'All Types'] },
  { label: '73. Car guide-rails & brackets', categories: ['Pit', 'All Types'] },
  { label: '74. Cwt. guide-rails & brackets', categories: ['Pit', 'All Types'] },
  { label: '75. Buffers', categories: ['Pit', 'All Types'] },
  { label: '76. Car safety & tail rope', categories: ['Pit', 'All Types'] },
  { label: '77. Underside platform', categories: ['Pit', 'All Types'] },
  { label: '78. Tension weight', categories: ['Pit', 'All Types'] },
  { label: '79. Comp., chains, rope & switch', categories: ['Pit', 'All Types'] },
  { label: '80. Counterweight runby', categories: ['Pit', 'All Types'] },
  { label: '81. Counterweight runby signage', categories: ['Pit', 'All Types'] },
  { label: '82. Plunger gripper', categories: ['Pit', 'All Types'] },

  // Escalator/Moving Walk (#83–96)
  { label: '83. Fire shutters', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '84. Skirt switch', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '85. Skirt deflection device', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '86. Comb plate/Combo plate teeth', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '87. Landing plate/Impact switches', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '88. Hand rails/Handrail safeties', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '89. Step/Tread', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '90. Key switch', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '91. Emergency stop button', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '92. Decking and balustrades', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '93. Ceiling guards', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '94. Deck barricades', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '95. Internal safeties', categories: ['Escalator/Moving Walk', 'All Types'] },
  { label: '96. Safety signage', categories: ['Escalator/Moving Walk', 'All Types'] },

  // Entire Device (#97–100)
  { label: '97. Entire Device', categories: ['Entire Device', 'All Types'] },
  { label: '98. Current five year tag', categories: ['Entire Device', 'All Types'] },
  { label: '99. Current one year tag', categories: ['Entire Device', 'All Types'] },
  { label: '100. Miscellaneous', categories: ['Entire Device', 'All Types'] },
];

// Violating Condition
export const violatingConditionOptions = [
  'H. Worn',
  'I. Damaged',
  'J. Misaligned',
  'K. Rusted',
  'L. Defective',
  'M. Missing',
  'N. By-passed',
  'O. Dirty',
  'P. No means of access',
  'Q. Unguarded',
  'R. Illegal',
  'S. Not fire retardant',
  'T. Unlabeled',
  'U. Device not tagged',
  'V. Not level',
  'W. Unlocked',
  'X. Inoperative',
  'Y. Oil leak',
  'Z. Water leak',
  'AA. Carbon buildup',
  'BB. Expired Tag',
  'CC. DLM not working',
  'DD. DLM not installed',
  // etc...
];

// Suggested Remedy
export const suggestedRemedyOptions = [
  '01. Adjust',
  '02. Clean',
  '03. Install guards',
  '04. Patch',
  '05. Perform and file test',
  '06. Properly secure',
  '07. Provide',
  '08. Re-groove',
  '09. Remove',
  '10. Repair',
  '11. Replace',
  '12. Re-shackle',
  '13. Seal',
  '14. Shorten',
  '15. Tag device',
  '16. Provide means of access',
  '17. Re-inspection required',
  '18. Install',
  // etc...
];

// Resolution Method
export const resolutionMethodOptions = [
  'Under Contract',
  'Building To Comply',
  'Chargeable',
  'To Be Discussed',
  'Time and Materials',
  'No Charge',
  'Recommendation',
  'On prior proposal - approved',
  'On prior proposal - not approved',
  // etc...
];

// Item Status
export const itemStatusOptions = [
  'Must Remedy',
  'Completed',
  'Reinspection Needed',
  'Discharged',
  // etc...
];
